export interface NomoCharacter {
  id: string;
  name: string;
  enName: string;
  place: string;
  placeEn: string;
  flavor: string;
  wish: string;
  tagline: string;
  origin: string;
  image: string;
  tone: 'primary' | 'accent' | 'secondary';
  debut: boolean;
}

export const nomoCharacters: NomoCharacter[] = [
  {
    id: 'yu-doudou',
    name: '鱼豆豆',
    enName: 'YU DOUDOU',
    place: '杭州 · 西湖',
    placeEn: 'WEST LAKE · HANGZHOU',
    flavor: '西湖醋鱼',
    wish: '好运 · 好生活',
    tagline: '从西湖游出来的一条小鱼。',
    origin:
      '一味是鱼，一境是西湖，一愿是好生活。它圆滚滚、软乎乎，带着杭州的温柔，也带着一点松弛自在。',
    image:
      'https://readdy.ai/api/search-image?query=Cute%20rounded%20plump%20little%20fish%20designer%20vinyl%20art%20toy%20figure%20with%20soft%20cream%20and%20warm%20orange%20gradient%20body%20tiny%20smiling%20face%20small%20fins%20sitting%20on%20a%20green%20lotus%20leaf%20Chinese%20silk%20wave%20pattern%20accents%20plain%20warm%20beige%20studio%20background%20soft%20shadows%20collectible%20toy%20product%20photography%20high%20detail&width=1000&height=1000&seq=nomo-char-yudoudou-01&orientation=squarish',
    tone: 'primary',
    debut: true,
  },
  {
    id: 'la-dundun',
    name: '辣墩墩',
    enName: 'LA DUNDUN',
    place: '重庆 · 山城',
    placeEn: 'MOUNTAIN CITY · CHONGQING',
    flavor: '麻辣火锅',
    wish: '红火 · 热闹',
    tagline: '一锅热辣里，长大的一团火。',
    origin:
      '一味是火锅，一境是山城江湖，一愿是日子红火。辣墩墩脾气热、心肠软，谁靠近都想被它请一顿。',
    image:
      'https://readdy.ai/api/search-image?query=Cute%20chubby%20playful%20hotpot%20themed%20designer%20art%20toy%20character%20in%20deep%20red%20and%20warm%20orange%20colors%20with%20tiny%20chili%20pepper%20motif%20on%20its%20head%20rounded%20body%20warm%20beige%20studio%20background%20soft%20shadows%20collectible%20vinyl%20toy%20product%20photography%20high%20detail&width=1000&height=1000&seq=nomo-char-ladundun-01&orientation=squarish',
    tone: 'primary',
    debut: false,
  },
  {
    id: 'mian-changchang',
    name: '面长长',
    enName: 'MIAN CHANGCHANG',
    place: '成都 · 天府',
    placeEn: 'TIANFU · CHENGDU',
    flavor: '甜水面',
    wish: '长久 · 康健',
    tagline: '把长长的心意，绕成一条面。',
    origin:
      '一味是甜水面，一境是川西平原的闲适，一愿是长长久久。它慢吞吞，却把每一份祝福拉得又长又韧。',
    image:
      'https://readdy.ai/api/search-image?query=Cute%20little%20noodle%20themed%20designer%20art%20toy%20character%20cream%20and%20wheat%20golden%20tones%20with%20long%20flowing%20noodle%20scarf%20wrapped%20around%20body%20gentle%20smiling%20face%20plain%20warm%20beige%20studio%20background%20soft%20shadows%20collectible%20vinyl%20toy%20product%20photography%20high%20detail&width=1000&height=1000&seq=nomo-char-mianchangchang-01&orientation=squarish',
    tone: 'accent',
    debut: false,
  },
  {
    id: 'ya-longlong',
    name: '鸭珑珑',
    enName: 'YA LONGLONG',
    place: '北京 · 皇城',
    placeEn: 'IMPERIAL CITY · BEIJING',
    flavor: '北京烤鸭',
    wish: '圆满 · 富足',
    tagline: '胡同里，最讲究的一只金鸭子。',
    origin:
      '一味是烤鸭，一境是帝都胡同，一愿是圆满丰足。它外表油亮讲究，内里却是热心肠的老北京。',
    image:
      'https://readdy.ai/api/search-image?query=Adorable%20plump%20roast%20duck%20designer%20vinyl%20art%20toy%20character%20with%20glossy%20lacquered%20crimson%20red%20and%20antique%20gold%20finish%20standing%20upright%20wearing%20a%20tiny%20imperial%20dragon%20robe%20with%20golden%20cloud%20embroidery%20and%20a%20small%20crown%20while%20holding%20a%20fresh%20scallion%20leek%20twig%20against%20a%20warm%20cream%20studio%20backdrop%20gentle%20soft%20shadows%20collectible%20designer%20toy%20product%20photography%20high%20detail&width=1000&height=1000&seq=nomo-char-yalonglong-01&orientation=squarish&nocache=true',
    tone: 'accent',
    debut: false,
  },
  {
    id: 'xia-jiaojiao',
    name: '虾饺饺',
    enName: 'XIA JIAOJIAO',
    place: '广东 · 岭南',
    placeEn: 'LINGNAN · GUANGDONG',
    flavor: '早茶虾饺',
    wish: '团圆 · 聚首',
    tagline: '一笼点心，装下一桌子热闹。',
    origin:
      '一味是虾饺，一境是岭南水乡，一愿是团圆相聚。它最爱热闹，一笼就能召唤一大家子人围坐。',
    image:
      'https://readdy.ai/api/search-image?query=Adorable%20chubby%20shrimp%20dumpling%20designer%20vinyl%20art%20toy%20character%20with%20glossy%20jade%20green%20and%20warm%20coral%20pink%20ceramic%20glaze%20finish%20standing%20upright%20and%20cheerfully%20holding%20a%20tiny%20porcelain%20tea%20cup%20with%20one%20paw%20wearing%20a%20miniature%20dim%20sum%20chef%20hat%20and%20a%20small%20red%20silk%20apron%20surrounded%20by%20delicate%20steamed%20dumpling%20illustrations%20and%20soft%20bamboo%20steam%20wisps%20against%20a%20warm%20cream%20studio%20backdrop%20gentle%20soft%20shadows%20collectible%20designer%20toy%20product%20photography%20high%20detail&width=1000&height=1000&seq=nomo-char-xiajiaojiao-01&orientation=squarish&nocache=true',
    tone: 'secondary',
    debut: false,
  },
];